import { render, staticRenderFns } from "./UpcommingBookings.vue?vue&type=template&id=6d9294bc&"
import script from "./UpcommingBookings.vue?vue&type=script&lang=ts&"
export * from "./UpcommingBookings.vue?vue&type=script&lang=ts&"
import style0 from "./UpcommingBookings.vue?vue&type=style&index=0&id=6d9294bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports